// src/api/linkInBioPublic.ts
//
// Public (unauthenticated) API functions for link-in-bio pages.
// Uses raw fetch() — no Axios, no auth interceptors.
// This module is imported by the lightweight public app and must not
// pull in any heavy dependencies.

import type { PublicPageData } from '@/types/linkInBio';

const API_URL = import.meta.env.VITE_API_URL;

export async function getPublicPage(slug: string): Promise<PublicPageData> {
  const response = await fetch(`${API_URL}/public/link-in-bio/${slug}`);
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
  return response.json();
}

export async function logPageEvent(
  slug: string,
  event: {
    event_type: string;
    link_id?: string;
    link_label?: string;
    referrer?: string;
    tracking_id?: string;
  },
): Promise<void> {
  await fetch(`${API_URL}/public/link-in-bio/${slug}/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  });
}

export async function submitEmailSignup(slug: string, email: string): Promise<void> {
  const response = await fetch(`${API_URL}/public/link-in-bio/${slug}/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
}

export async function reportPage(
  slug: string,
  reason: string,
  details?: string,
): Promise<void> {
  await fetch(`${API_URL}/public/link-in-bio/${slug}/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason, details }),
  });
}
